module.exports = __webpack_public_path__ + "img/dashboard-icon-green.0a52a130.svg";